import { Badge } from '@lilith-arcana-os/ui';

interface PageHeaderProps {
  eyebrow: string;
  title: string;
  description: string;
  badge?: string;
}

export function PageHeader({ badge, description, eyebrow, title }: PageHeaderProps) {
  return (
    <div className="mb-6 space-y-3">
      <p className="text-xs uppercase tracking-[0.35em] text-[var(--la-text-muted)]">{eyebrow}</p>
      <div className="flex items-center justify-between gap-3">
        <h1 className="font-heading text-3xl text-[var(--la-text)]">{title}</h1>
        {badge ? <Badge tone="gold">{badge}</Badge> : null}
      </div>
      <p className="max-w-xl text-base text-[var(--la-text-muted)]">{description}</p>
    </div>
  );
}
